import { DegreeLevelOption } from '@uc/web/shared/data-models';
import { TopDegreeSubject } from '../models/course-degree-hub.models';

export const METADATA = {
	title: 'Search University Courses, UK',
	description:
		'Discover university courses in the UK. Explore student reviews, fees, grants, and find information on university courses at Uni Compare.',
};

export const HEADER_DATA = {
	description:
		"Use our university courses search to find a course at a UK university. Explore university courses by subject, course name or the region you'd like to study in. Easily find the perfect university courses with our search tool from thousands of options.",
};

export const INFO_SECTION = {
	title: 'Discover thousands of courses',
	description:
		'Take your next step in higher education with thousands of courses right at your fingertips! From undergrad to postgrad, diplomas to honours, explore all your options so you can be confident in the choice you make.',
};

export const UNDERGRADUATE_CARD = {
	title: 'Find undergraduate courses',
	desc: 'Take your first step to university and explore all undergraduate courses - Bachelor’s degrees, HND, HNC and more.',
	image: '/assets/img/clearing_courses_cta.png',
	link: '/courses/degrees/undergraduate',
	external: false,
};

export const POSTGRADUATE_CARD = {
	title: 'Discover postgraduate courses',
	desc: 'Specialise further in your studies with a postgraduate course. Explore course options across the country to find the right university to support your learning.',
	image: '/assets/img/courses_hub_postgraduate_cta_card.png',
	link: '/courses/degrees/postgraduate',
	external: false,
};

export const CLEARING_CARD = {
	title: 'Find Clearing courses',
	desc: '[CLEARING_STATUS] Find all the latest courses and universities in Clearing right here.',
	image: '/assets/img/all_clearing_info_cta.png',
	link: '/courses/clearing',
	external: false,
};

export const DIRECTORY_CARD = {
	title: 'Directory',
	desc: 'Don’t see your subject here? Access the A-Z of subjects available in our directory.',
	image: '/assets/img/course-search-directory-CTA.png',
	link: '/directory',
	external: false,
};

export const DEGREE_LEVEL_OPTIONS: DegreeLevelOption[] = [
	{ label: 'Undergraduate', link: 'undergraduate' },
	{ label: "Bachelor's", link: 'degrees' },
	{ label: 'HND', link: 'hnd' },
	{ label: 'HNC', link: 'hnc' },
	{
		label: 'Access to Higher Education',
		link: 'access-to-higher-education',
	},
	{
		label: 'Foundation',
		link: 'foundation',
	},
	{
		label: 'Undergraduate Certificates & Diplomas',
		link: 'undergraduate-certificate-diplomas',
	},
	{ label: 'Postgraduate', link: 'postgraduate' },
	{ label: "Master's", link: 'masters' },
	{ label: 'PGCE courses', link: 'pgce' },
	{ label: 'PhD', link: 'phd' },
	{ label: 'Postgraduate Diploma', link: 'postgraduate-diploma' },
	{
		label: 'Postgraduate Certificate',
		link: 'postgraduate-certificate',
	},
	{
		label: 'Postgraduate Certificates & Diplomas',
		link: 'postgraduate-certificate-diplomas',
	},
	{
		label: 'Clearing',
		link: 'clearing',
	},
];

export const PRIORITISED_DEGREES_LIST: TopDegreeSubject[] = [
	{
		title: 'Popular Bachelor’s degrees',
		subjects: [
			{
				name: 'Accounting',
				link: 'accounting',
			},
			{
				name: 'Biochemistry',
				link: 'biochemistry',
			},
			{
				name: 'Biology',
				link: 'biology',
			},
			{
				name: 'Business studies',
				link: 'business-studies',
			},
			{
				name: 'Media and communication studies',
				link: 'media-and-communication-studies',
			},
			{
				name: 'Computer science',
				link: 'computer-science',
			},
			{
				name: 'Construction management',
				link: 'construction-management',
			},
			{
				name: 'Criminology',
				link: 'criminology',
			},
			{
				name: 'Environmental sciences',
				link: 'environmental-sciences',
			},
			{
				name: 'Forensic psychology',
				link: 'forensic-psychology',
			},
			{
				name: 'Forensic science',
				link: 'forensic-science',
			},
			{
				name: 'International relations',
				link: 'international-relations',
			},
			{
				name: 'Law',
				link: 'law',
			},
			{
				name: 'Marine biology',
				link: 'marine-biology',
			},
			{
				name: 'Mechanical engineering',
				link: 'mechanical-engineering',
			},
			{
				name: 'Midwifery',
				link: 'midwifery',
			},
			{
				name: 'Medical sciences',
				link: 'medical-sciences',
			},
			{
				name: 'Nursing',
				link: 'nursing',
			},
			{
				name: 'Nutrition',
				link: 'nutrition',
			},
			{
				name: 'Project management',
				link: 'project-management',
			},
			{
				name: 'Psychology',
				link: 'psychology',
			},
			{
				name: 'Social work',
				link: 'social-work',
			},
			{
				name: 'Social sciences',
				link: 'social-sciences',
			},
			{
				name: 'Software engineering',
				link: 'software-engineering',
			},
			{
				name: 'Sport and exercise sciences',
				link: 'sport-and-exercise-sciences',
			},
			{
				name: 'Sport and exercise psychology',
				link: 'sport-and-exercise-psychology',
			},
			{
				name: 'Theology',
				link: 'theology',
			},
		],
	},
];
